type Position = 'absolute' | 'relative' | undefined;
type Justify = 'center' | 'initial' | 'inherit' | 'unset' | 'flex-start' | 'flex-end';

type Direction = 'row' | 'column' | 'row-reverse' | 'column-reverse' | undefined;
type FontStyle = 'normal' | 'italic';
type TextAlign = 'center' | 'left' | 'right' | undefined;
type FlexAlign = 'initial' | 'inherit' | 'unset' | 'row' | 'row-reverse' | 'column' | 'column-reverse' | 'center' | 'flex-start' | 'flex-end' | 'stretch' | undefined;
type ResizeMode = 'cover' | 'contain' | 'stretch' | 'center' | 'repeat' | undefined;
type ObjectFit = 'none' | 'initial' | 'inherit' | 'unset' | 'contain' | 'cover' | '-moz-initial' | 'revert' | 'fill' | 'scale-down' | undefined;

export const CLASSES = {
    TopLevelComment: 'TopLevelComment',
    OnHoverTextSuggestionInput: 'OnHoverTextSuggestionInput'
};

export const CONSTANTS = {
    NONE: 'none',
    FLEX: 'flex',
    COLORS: {
        DARK_BLUE_GREY: '#423F4E',
        SUB_NAV_BAR: '#F5F5F5',
        LIGHT_GREY: '#CCCCCC',
        BLUE: '#3077B4',
        TRANSPARENT: '#00000000',
        DARK_TEXT: '#0E0E0F',
        WHITE: '#FFF'
    },
    display: {
        INLINE_BLOCK: 'inline-block',
        INLINE: 'inline',
        BLOCK: 'block'
    },
    font: {
        REGULAR: 'ProximaNovaRegular',
        REGULAR_ITALIC: 'ProximaNovaRegularIta',
        BOLD: 'ProximaNovaBold',
        BOLD_ITALIC: 'ProximaNovaBoldIta',
        LIGHT: 'ProximaNovaLight',
        LIGHT_ITALIC: 'ProximaNovaRegularIta',
        SEMIBOLD: 'ProximaNovaSemibold',
        SEMIBOLD_ITALIC: 'ProximaNovaSemiboldIta'
    },
    float: {
        RIGHT: 'right',
        LEFT: 'left'
    },
    position: {
        ABSOLUTE: 'absolute' as Position,
        RELATIVE: 'relative' as Position
    },
    flexAlign: {
        CENTER: 'center' as Justify,
        STRETCH: 'stretch' as Justify,
        START: 'flex-start' as Justify,
        END: 'flex-end' as FlexAlign
    },
    flexJustify: {
        CENTER: 'center' as Justify,
        END: 'flex-end' as Justify,
        START: 'flex-start' as Justify,
        SPACE_BETWEEN: 'space-between' as Justify,
        SPACE_AROUND: 'space-around' as Justify
    },
    flexDirection: {
        ROW: 'row' as Direction,
        COLUMN: 'column' as Direction
    },
    fontStyle: {
        NORMAL: 'normal' as FontStyle,
        ITALIC: 'italic' as FontStyle
    },
    fontWeight: {
        LIGHT: '300',
        NORMAL: '400',
        SEMI_BOLD: '500',
        BOLD: '700'
    },
    fontSize: {
        SMALL: 12,
        DEFAULT: 14,
        MEDIUM: 16,
        LARGE: 20,
        X_LARGE: 22,
        XX_LARGE: 24
    },
    objectFit: {
        CONTAIN: 'contain',
        COVER: 'cover'
    } as {[key: string]: ObjectFit},
    textAlign: {
        AUTO: 'auto' as TextAlign,
        LEFT: 'left' as TextAlign,
        CENTER: 'center' as TextAlign,
        RIGHT: 'right' as TextAlign,
        JUSTIFY: 'justify' as TextAlign
    },
    textDecoration: {
        NONE: 'none',
        UNDERLINE: 'underline',
        LINE_THROUGH: 'line-through',
        UNDERLINE_LINE_THROUGH: 'underline line-through'
    },
    image: {
        resizeMode: {
            COVER: 'cover' as ResizeMode,
            CONTAIN: 'contain' as ResizeMode,
            STRETCH: 'stretch' as ResizeMode,
            REPEAT: 'repeat' as ResizeMode,
            CENTER: 'center' as ResizeMode
        }
    }
};



// WEBPACK FOOTER //
// ./src/styles/styleConstants.ts